import gql from "graphql-tag"

const mutation = gql`
  mutation Logout {
    loginLogout
  }
`

export const toString = mutation.loc.source.body

export default mutation
